module.exports = __webpack_public_path__ + "static/media/Uplands Road N8 (9).213c7f05.JPG";